import React, { useCallback, useEffect } from "react";
import flipButton from "assets/images/dw20/flip-btn.png";
import DidYouKnow from "../components/DidYouKnow";
import _ from "lodash";
import Socket from "socket";
import { motion } from "framer-motion/dist/framer-motion";
import {
  divVariants,
  fadeVariants,
  staticBounceVariants
} from "shared/components/animations";
const DW20PrePlay = ({
  isCzarPlayer,
  roomId,
  screens,
  joke,
  buzzer_sound,
  default_audio_effect
}) => {
  const flipButtonClickAction = () => {
    const data = {
      action: "update-status",
      roomId
    };

    Socket.sendMessage(data);
  };
  const handleFlipButtonClick = useCallback(
    _.debounce(() => flipButtonClickAction(), 1000, {
      leading: true,
      trailing: false
    }),
    []
  );

  const banner_text = _.get(
    screens,
    "1_preplay.czar.banner_text",

    "You're the Card Czar."
  );
  const rules_bottom_text = _.get(
    screens,
    "1_preplay.czar.rules_bottom_text",

    "Flip the active card using the button below when ready!"
  );
  const other_ready_text = _.get(
    screens,
    "1_preplay.other.ready_text",

    "Get Ready!"
  );
  const other_rules_label = _.get(
    screens,
    "1_preplay.other.rules_label",

    "Rules"
  );
  const button_text = _.get(
    screens,
    "1_preplay.czar.button_text",

    "FLIP"
  );
  const czar_rules_text = _.get(screens, "1_preplay.czar.rules_text");
  const other_rules_text = _.get(screens, "1_preplay.other.rules_text");

  useEffect(() => {
    if (isCzarPlayer && !_.isEmpty(default_audio_effect)) {
      buzzer_sound();
    }
  }, [buzzer_sound, isCzarPlayer, default_audio_effect]);

  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="dw-preplay"
    >
      <div>
        <motion.h3 variants={fadeVariants} className="heading">
          {other_ready_text}
        </motion.h3>
        {isCzarPlayer && (
          <motion.p variants={staticBounceVariants} className="you-czar ">
            {banner_text}
          </motion.p>
        )}
        <motion.div variants={staticBounceVariants} className="rules-card">
          <h4 className="rule-text">{other_rules_label}</h4>
          {isCzarPlayer ? (
            <ul>
              {czar_rules_text?.map((rule, index) => (
                <li key={index}>{rule}</li>
              ))}
            </ul>
          ) : (
            <ul>
              {other_rules_text?.map((rule, index) => (
                <li key={index}>{rule}</li>
              ))}
            </ul>
          )}

          {isCzarPlayer && <p className="high-text">{rules_bottom_text}</p>}
        </motion.div>

        {isCzarPlayer && (
          <div className="text-center">
            <motion.img
              variants={staticBounceVariants}
              src={flipButton}
              className="img-fluid flipButton"
              alt="Flip"
              onClick={handleFlipButtonClick}
            />
            <motion.p variants={fadeVariants}>{button_text}</motion.p>
          </div>
        )}
      </div>

      {!isCzarPlayer && <DidYouKnow joke={joke} />}
    </motion.div>
  );
};

export default DW20PrePlay;
